import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, withKeys as _withKeys, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../../assets/img/bl-2024.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "navbar-mobile-backdrop" }, null, -1)
const _hoisted_2 = { class: "navbar-middle" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "navbar-middle__row" }
const _hoisted_5 = {
  href: "/",
  class: "navbar-middle__main-logo",
  title: "RTL címlap"
}
const _hoisted_6 = { class: "navbar-middle__menu-swap" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { id: "site-placeholder--footer" }, null, -1)
const _hoisted_8 = { class: "navbar-middle__auth" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "navbar-middle__newsletter-label" }, " Hírlevél ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_14 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 0,
  class: "navbar-main"
}
const _hoisted_16 = { class: "container" }
const _hoisted_17 = { class: "navbar-main__row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_22 = [
  _hoisted_18,
  _hoisted_19,
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = {
  key: 0,
  class: "navbar-main__items"
}
const _hoisted_24 = ["alt"]
const _hoisted_25 = {
  key: 1,
  class: "navbar-main__items"
}
const _hoisted_26 = ["alt"]
const _hoisted_27 = { class: "container" }
const _hoisted_28 = { class: "navigation__logo" }
const _hoisted_29 = { href: "/" }
const _hoisted_30 = { class: "navigation__mobile-wrapper" }
const _hoisted_31 = { class: "navigation__rtlmost" }
const _hoisted_32 = {
  key: 0,
  class: "navigation__tags"
}
const _hoisted_33 = ["alt"]
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "navigation__search" }
const _hoisted_36 = {
  type: "submit",
  class: "navigation__search-btn"
}
const _hoisted_37 = {
  key: 1,
  class: "navigation__row"
}
const _hoisted_38 = { class: "navigation__col" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("h1", { class: "navigation__title" }, "Műsorok", -1)
const _hoisted_40 = { class: "navigation__list" }
const _hoisted_41 = { class: "navigation__col" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h1", { class: "navigation__title" }, "Témák", -1)
const _hoisted_43 = { class: "navigation__list" }
const _hoisted_44 = { class: "navigation__bottom" }
const _hoisted_45 = { class: "navigation__social" }
const _hoisted_46 = { class: "navigation__copyright" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", {
  id: "site-placeholder--header",
  class: "navbar-extra"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SliderLeft = _resolveComponent("SliderLeft")!
  const _component_main_logo = _resolveComponent("main-logo")!
  const _component_vote_banner = _resolveComponent("vote-banner")!
  const _component_banner_widget = _resolveComponent("banner-widget")!
  const _component_newsletter = _resolveComponent("newsletter")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DarkMode = _resolveComponent("DarkMode")!
  const _component_search = _resolveComponent("search")!
  const _component_rtl_plus = _resolveComponent("rtl-plus")!
  const _component_nav_link = _resolveComponent("nav-link")!
  const _component_TagX = _resolveComponent("TagX")!
  const _component_facebook_full = _resolveComponent("facebook-full")!
  const _component_instagram = _resolveComponent("instagram")!
  const _component_twitter = _resolveComponent("twitter")!
  const _component_social_media_links = _resolveComponent("social-media-links")!

  return (_openBlock(), _createElementBlock("header", {
    ref: "header",
    class: _normalizeClass(["main-header", { 'main-header--open': _ctx.isNavOpen }])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_Transition, { name: "navbar-middle__back-nav-anim" }, {
            default: _withCtx(() => [
              (_ctx.navBackVisible)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "navbar-middle__back-nav",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                  }, [
                    _createVNode(_component_SliderLeft, { class: "navbar-middle__back-nav-icon" })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createElementVNode("a", _hoisted_5, [
            _createVNode(_component_main_logo, {
              onClickCapture: _cache[1] || (_cache[1] = ($event: any) => (_ctx.measure('RTL Logo')))
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.$route?.meta?.votePromo)
              ? (_openBlock(), _createBlock(_component_vote_banner, {
                  key: 0,
                  class: "navbar-middle__vote-banner",
                  link: _ctx.$route.meta.votePromo.link,
                  title: _ctx.$route.meta.votePromo.banner.title,
                  background: _ctx.$route.meta.votePromo.banner.bg_image,
                  color: _ctx.$route.meta.votePromo.banner.bg_color,
                  logo: _ctx.$route.meta.votePromo.banner.logo,
                  "vote-id": _ctx.$route.meta.votePromo.vote?.id,
                  "vote-group-id": _ctx.$route.meta.votePromo.vote?.group_id
                }, null, 8, ["link", "title", "background", "color", "logo", "vote-id", "vote-group-id"]))
              : _createCommentVNode("", true),
            _hoisted_7,
            _createVNode(_component_banner_widget, {
              class: "navbar-middle__banner",
              zone: { mobile: 'm_special', app: 'app_special' },
              "label-position": "",
              "show-background": false,
              "show-placeholder": false
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_router_link, {
              class: "navbar-middle__newsletter",
              to: { name: 'newsletter' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_newsletter),
                _hoisted_9
              ]),
              _: 1
            }),
            (_ctx.theme !== 'dark')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "navbar-middle__icon navbar-middle__light",
                  role: "button",
                  tabindex: "0",
                  "aria-label": "Sötét módra váltás",
                  onKeypress: [
                    _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.theme = 'dark'), ["enter"])),
                    _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.theme = 'dark'), ["space"]))
                  ],
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.theme = 'dark'))
                }, [
                  _createVNode(_component_DarkMode, { theme: 'light' })
                ], 32))
              : _createCommentVNode("", true),
            (_ctx.theme !== 'light')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "navbar-middle__icon navbar-middle__dark",
                  role: "button",
                  tabindex: "0",
                  "aria-label": "Világos módra váltás",
                  onKeypress: [
                    _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.theme = 'light'), ["enter"])),
                    _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.theme = 'light'), ["space"]))
                  ],
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.theme = 'light'))
                }, [
                  _createVNode(_component_DarkMode, { theme: 'dark' })
                ], 32))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              to: { name: 'search' },
              class: "navbar-middle__icon navbar-middle__search"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_search, {
                  onClickCapture: _cache[8] || (_cache[8] = ($event: any) => (_ctx.measure('Keresés')))
                })
              ]),
              _: 1
            }),
            _createVNode(_component_nav_link, {
              to: "https://www.rtlplusz.hu",
              target: "_blank",
              class: "navbar-middle__rtl"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_rtl_plus, {
                  onClickCapture: _cache[9] || (_cache[9] = ($event: any) => (_ctx.measure('RTL+ Logo'))),
                  height: "24",
                  alt: "RTL+"
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["navbar-middle__mobile-toggle", { 'navbar-middle__mobile-toggle--open': _ctx.isNavOpen }]),
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.toggleMobileMenu()))
          }, _hoisted_14, 2)
        ])
      ])
    ]),
    (_ctx.menus)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", {
                class: _normalizeClass(["navbar-main__toggle", { 'navbar-main__toggle--open': _ctx.isNavOpen }]),
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.toggleMenu()))
              }, _hoisted_22, 2),
              (_ctx.menus.trendingTags)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus.trendingTags.menuItems, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "navbar-main__item",
                        key: item.id
                      }, [
                        _createVNode(_component_nav_link, {
                          to: item.targetUrl,
                          target: item.target,
                          class: _normalizeClass(["navbar-main__link", {
                  'navbar-main__link--2022': _ctx.isElectionMenu(item.targetUrl),
                  'navbar-main__link--custom': item.label === 'Bajnokok Ligája'
                }])
                        }, {
                          default: _withCtx(() => [
                            (item.label === 'Bajnokok Ligája')
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  width: "128",
                                  height: "24",
                                  src: _imports_0,
                                  alt: item.label
                                }, null, 8, _hoisted_24))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (_ctx.isElectionMenu(item.targetUrl))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createVNode(_component_TagX),
                                        _createVNode(_component_TagX)
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(item.label), 1)
                                ], 64))
                          ]),
                          _: 2
                        }, 1032, ["to", "target", "class"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.menus.trendingShows)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus.trendingShows.menuItems, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "navbar-main__item",
                        key: item.id
                      }, [
                        _createVNode(_component_nav_link, {
                          to: item.targetUrl,
                          target: item.target,
                          class: _normalizeClass(["navbar-main__link", {
                  'navbar-main__link--2022': _ctx.isElectionMenu(item.targetUrl),
                  'navbar-main__link--custom': item.label === 'Bajnokok Ligája'
                }])
                        }, {
                          default: _withCtx(() => [
                            (item.label === 'Bajnokok Ligája')
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  width: "128",
                                  height: "24",
                                  src: _imports_0,
                                  alt: item.label
                                }, null, 8, _hoisted_26))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (_ctx.isElectionMenu(item.targetUrl))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createVNode(_component_TagX),
                                        _createVNode(_component_TagX)
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(item.label), 1)
                                ], 64))
                          ]),
                          _: 2
                        }, 1032, ["to", "target", "class"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("nav", {
      class: _normalizeClass(["navigation", { 'navigation--open': _ctx.isNavOpen }])
    }, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("a", _hoisted_29, [
            _createVNode(_component_main_logo, {
              onClickCapture: _cache[12] || (_cache[12] = ($event: any) => (_ctx.measure('RTL Logo')))
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_nav_link, {
              to: "https://www.rtlplusz.hu",
              target: "_blank",
              class: "navbar-middle__rtl"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_rtl_plus, {
                  onClickCapture: _cache[13] || (_cache[13] = ($event: any) => (_ctx.measure('RTL+ Logo'))),
                  height: "24",
                  alt: "RTL+"
                })
              ]),
              _: 1
            })
          ]),
          (_ctx.menus)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...(_ctx.menus.trendingTags?.menuItems || []), ...(_ctx.menus.trendingShows?.menuItems || [])], (item) => {
                  return (_openBlock(), _createBlock(_component_nav_link, {
                    key: item.id,
                    to: item.targetUrl,
                    target: item.target,
                    class: _normalizeClass(["tag", {
                'navbar-main__link--2022': _ctx.isElectionMenu(item.targetUrl)
              }]),
                    style: _normalizeStyle(item.label === 'Bajnokok Ligája' ? { padding: 0 } : null)
                  }, {
                    default: _withCtx(() => [
                      (item.label === 'Bajnokok Ligája')
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            width: "128",
                            height: "24",
                            src: _imports_0,
                            alt: item.label
                          }, null, 8, _hoisted_33))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_ctx.isElectionMenu(item.targetUrl))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createVNode(_component_TagX),
                                  _createVNode(_component_TagX)
                                ], 64))
                              : (_openBlock(), _createElementBlock("span", _hoisted_34, "#")),
                            _createTextVNode(" " + _toDisplayString(item.label), 1)
                          ], 64))
                    ]),
                    _: 2
                  }, 1032, ["to", "target", "class", "style"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("form", {
              class: "navigation__input-wrapper",
              onSubmit: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["prevent"]))
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "Keresés...",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.searchText) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchText]
              ]),
              _createElementVNode("button", _hoisted_36, [
                _createVNode(_component_search)
              ])
            ], 32)
          ]),
          (_ctx.menus)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("ul", _hoisted_40, [
                    (_ctx.menus.hamburgerShows)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.menus.hamburgerShows.menuItems, (item) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "navigation__list-item",
                            key: item.id
                          }, [
                            _createVNode(_component_nav_link, {
                              to: item.targetUrl,
                              target: item.target
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["to", "target"])
                          ]))
                        }), 128))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _createElementVNode("ul", _hoisted_43, [
                    (_ctx.menus.hamburgerTags)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.menus.hamburgerTags.menuItems, (item) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "navigation__list-item",
                            key: item.id
                          }, [
                            _createVNode(_component_nav_link, {
                              to: item.targetUrl,
                              target: item.target,
                              style: _normalizeStyle({ color: item.targetUrl === '/cimke/europa' ? '#0C4DA2' : null })
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["to", "target", "style"])
                          ]))
                        }), 128))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_social_media_links, null, {
              default: _withCtx(({ facebook, instagram, twitter }) => [
                facebook
                  ? (_openBlock(), _createBlock(_component_nav_link, {
                      key: 0,
                      to: facebook,
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_facebook_full)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true),
                instagram
                  ? (_openBlock(), _createBlock(_component_nav_link, {
                      key: 1,
                      to: instagram,
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_instagram)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true),
                twitter
                  ? (_openBlock(), _createBlock(_component_nav_link, {
                      key: 2,
                      to: twitter,
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_twitter)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("span", _hoisted_46, _toDisplayString(new Date().getFullYear()) + " © RTL Magyarország.", 1)
        ])
      ])
    ], 2),
    _hoisted_47
  ], 2))
}